import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

import type { ConsultStyle, GradeCode, SexCode } from '@/api/model/userType'

interface UserInfo {
  user_id: number
  type16_id: number | null
  nickname: string
  sex_code: SexCode | null
  school_name: string | null
  birthday: string | null
  grade_code: GradeCode | null
  mbti: string | null
  join_path: string | null
  join_key: string | null
  consult_style: ConsultStyle | null
  is_agree: boolean | null
  email: string | null
}

interface UserStore {
  userInfo: UserInfo
  setUserInfo: (userInfo: UserInfo) => void
  clearUserInfo: () => void
}

export const useUserStore = create<UserStore>()(
  persist(
    (set, _get) => ({
      userInfo: {
        user_id: 0,
        type16_id: null,
        nickname: '',
        sex_code: null,
        school_name: null,
        birthday: null,
        grade_code: null,
        mbti: null,
        join_path: null,
        join_key: null,
        consult_style: null,
        is_agree: null,
        email: null
      },
      setUserInfo: (userInfo: UserInfo) => {
        set({ userInfo })
      },
      clearUserInfo: () => {
        set({
          userInfo: {
            user_id: 0,
            type16_id: null,
            nickname: '',
            sex_code: null,
            school_name: null,
            birthday: null,
            grade_code: null,
            mbti: null,
            join_path: null,
            join_key: null,
            consult_style: null,
            is_agree: null,
            email: null
          }
        })
      }
    }),
    {
      name: 'user-info',
      storage: createJSONStorage(() => localStorage)
    }
  )
)
